<template>
  <div>
    <div class="mt-4">
      <v-card-title>
        <v-row class="py-2">
          <v-col lg="6" md="6" sm="12" class="col-12">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-4" v-on="on" fab dark small color="primary" @click="agregar()">
                  <v-icon small dark>fas fa-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-4" v-on="on" fab dark small color="primary" @click="openDialogUpload()">
                  <v-icon small dark>fas fa-cloud-upload-alt</v-icon>
                </v-btn>
              </template>
              <span>Importar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-4" v-on="on" fab dark small color="primary" @click="exportar()">
                  <v-icon small dark>fas fa-arrow-alt-circle-down</v-icon>
                </v-btn>
              </template>
              <span>Exportar</span>
            </v-tooltip>
          </v-col>
          <v-col lg="3" md="3" sm="6" class="col-12">
            <v-select :items="filtroOpciones" class="px-4" v-model="filtro"> </v-select>
          </v-col>
          <v-col lg="3" md="3" sm="6" class="col-12">
            <v-text-field
              class="px-4"
              v-model="search"
              append-icon=" fas fa-search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-dialog v-model="dialogUpload" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">Importar</v-card-title>
          <div class="px-5">
            <v-file-input
              show-size
              label="Archivo"
              accept=".xlsx,.xls,.csv"
              truncate-length="50"
              @change="changeFileUpload"
            ></v-file-input>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialogUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="acceptDialogUpload">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        v-model="seleccionado"
        :headers="headers"
        :items="listadoPlatos"
        :search="search"
        class="elevation-0 border"
        multi-sort
        :single-select="false"
        item-key="idplato"
        show-select
        :mobile-breakpoint="0"
        :items-per-page="pagina"
        no-results-text="No se encontraron datos"
        no-data-text="No se encontraron datos"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-divider class="mx-4" inset vertical></v-divider>
            <div class="text-center">
              <v-menu bottom offset-y ref="openMenu">
                <template v-slot:activator="{ on: menu }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn class="mx-2" fab small color="primary" v-on="{ ...tooltip, ...menu }">
                        <v-icon small>fas fa-ellipsis-v</v-icon>
                      </v-btn>
                    </template>
                    <span>Acciones</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item @click.stop="cambiarEstado('H')">
                    <v-list-item-title> Habilitar </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click.stop="cambiarEstado('D')">
                    <v-list-item-title> Deshabilitar </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-toolbar>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.desayuno="{ item }">
          <v-icon color="red" small v-if="item.desayuno == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.desayuno == 1">fas fa-check</v-icon>
        </template>
        <template v-slot:item.almuerzo="{ item }">
          <v-icon color="red" small v-if="item.almuerzo == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.almuerzo == 1">fas fa-check</v-icon>
        </template>
        <template v-slot:item.cena="{ item }">
          <v-icon color="red" small v-if="item.cena == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.cena == 1">fas fa-check</v-icon>
        </template>
        <template v-slot:item.aceptataper="{ item }">
          <v-icon color="red" small v-if="item.aceptataper == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.aceptataper == 1">fas fa-check</v-icon>
        </template>
        <template v-slot:item.activo="{ item }">
          <v-icon color="green" small v-if="item.activo == 1">fas fa-square-full</v-icon>
          <v-icon color="red" small v-else-if="item.activo == 0">fas fa-square-full</v-icon>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar" :timeout="2000" :color="color">
        {{ text }}
        <v-btn :color="color == 'red' ? 'white' : 'primary'" text @click="snackbar = false">
          Cerrar
        </v-btn>
      </v-snackbar>
      <GestionPlatosPopup
        ref="gestionpopup"
        @guardar="guardar"
        @deleteDuplicados="deleteDuplicados"
        :listadoPlatos="listadoPlatosAux"
        :dialog="dialogPopup"
        @open="openPopup()"
        @close="closePopup()"
      ></GestionPlatosPopup>
    </div>
  </div>
</template>

<script>
import GestionPlatoService from '../services/GestionPlatoService';
import XLSX from 'xlsx';
export default {
  name: 'GestionPlatosLista',
  components: {
    GestionPlatosPopup: () => import('../components/GestionPlatosPopup')
  },
  data: () => ({
    snackbar: false,
    text: '',
    color: '',
    fileUpload: null,
    dialogUpload: false,
    seleccionado: [],
    search: '',
    filtro: '',
    filtroOpciones: [
      { text: 'TODOS', value: '' },
      { text: 'HABILITADOS', value: '1' },
      { text: 'DESHABILITADOS', value: '0' }
    ],
    dialogPopup: false,
    headers: [
      { text: 'idplato', value: 'idplato' },
      { text: 'descripcion', value: 'descripcion' },
      { text: 'descripcioncorta', value: 'descripcioncorta' },
      { text: 'desayuno', value: 'desayuno' },
      { text: 'almuerzo', value: 'almuerzo' },
      { text: 'cena', value: 'cena' },
      { text: 'aceptataper', value: 'aceptataper' },
      { text: 'activo', value: 'activo' }
    ],
    listadoPlatos: [],
    listadoPlatosAux: [],
    gestionPlatoService: null
  }),
  computed: {
    pagina() {
      if (screen.width <= 600) return 5;
      else return 15;
    }
  },
  watch: {
    filtro() {
      this.iniciaListado();
    }
  },
  methods: {
    openPopup() {
      this.dialogPopup = true;
    },
    closePopup() {
      this.dialogPopup = false;
      this.listadoPlatosAux = [];
      this.closeDialogUpload();
    },
    open() {
      this.$emit('open');
    },
    close() {
      this.$emit('close');
    },
    openDialogUpload() {
      this.dialogUpload = true;
    },
    closeDialogUpload() {
      this.fileUpload = null;
      this.dialogUpload = false;
    },
    changeFileUpload($event) {
      this.fileUpload = $event;
    },
    async acceptDialogUpload() {
      if (this.fileUpload === null || this.fileUpload === undefined) return;
      let reader = new FileReader();
      reader.onload = async (e) => {
        let data = e.target.result;
        let fixedData = this.fixdata(data);
        let workbook = XLSX.read(btoa(fixedData), { type: 'base64' });
        let firstSheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[firstSheetName];
        const res = XLSX.utils.sheet_to_json(worksheet);
        this.dialogUpload = false;
        await this.visualizarPlatos(res);
      };
      reader.readAsArrayBuffer(this.fileUpload);
    },
    fixdata(data) {
      var o = '',
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    visualizarPlatos(val) {
      val.forEach((el) => {
        this.listadoPlatosAux.push({
          idplato: el.idplato,
          descripcion: el.descripcion,
          descripcioncorta: el.descripcioncorta,
          desayuno: el.desayuno,
          almuerzo: el.almuerzo,
          cena: el.cena,
          aceptataper: el.aceptataper,
          activo: 1,
          error: false,
          idempresa: localStorage.getItem('emp')
        });
      });
      this.openPopup();
    },
    deleteDuplicados() {
      this.listadoPlatosAux = this.listadoPlatosAux.filter((el) => el.error === false);
      this.$refs.gestionpopup.showEliminar = false;
    },
    async guardar() {
      if (this.listadoPlatosAux.length <= 0) return;
      const res = await this.gestionPlatoService.post().execResource('plato', {
        exportacion: [...this.listadoPlatosAux]
      });
      if (res.status) {
        this.$refs.gestionpopup.showEliminar = false;
        this.$refs.gestionpopup.text = res.message;
        this.$refs.gestionpopup.snackbar = true;
        this.listadoPlatosAux = [];
        this.closePopup();
        this.iniciaListado();
      } else {
        this.$refs.gestionpopup.showEliminar = true;
        this.listadoPlatosAux.map((element) => {
          element.error = false;
          return element;
        });
        for (const el of res.message) {
          this.listadoPlatosAux.map((element) => {
            if (el.idplato === element.idplato) {
              element.error = true;
            }
            return element;
          });
        }
        this.$refs.gestionpopup.text = 'Error en datos duplicados';
        this.$refs.gestionpopup.snackbar = true;
      }
    },
    async iniciaListado() {
      this.open();
      this.listadoPlatos = [];
      const res = await this.gestionPlatoService.get().execResource('platos', {
        idempresa: localStorage.getItem('emp'),
        activo: this.filtro
      });
      if (res.length > 0) {
        this.listadoPlatos = res;
        this.close();
      }
      this.close();
    },
    agregar() {
      this.$router.push({ path: '/comedor/gestion_plato/agregar' });
    },
    async seleccion(env) {
      await this.initialize(env);
    },
    async consultaApiEstado(data, val) {
      const res = await this.gestionPlatoService.put().execResource('estado', {
        data: data,
        value: val
      });
      if (res.status) {
        this.iniciaListado();
      }
      this.seleccionado = [];
    },
    cambiarEstado(val) {
      const aux = [];
      this.seleccionado.forEach((element) => {
        aux.push(element.idplato);
      });
      if (aux.length > 0) {
        switch (val) {
          case 'H':
            this.consultaApiEstado(aux, '1');
            break;
          case 'D':
            this.consultaApiEstado(aux, '0');
            break;
        }
      } else {
        this.snackbar = true;
        this.text = 'Seleccione al menos un elemento de la lista.';
        this.color = 'red';
      }
      this.$refs.openMenu.isActive = false;
    },
    exportar() {
      const token = localStorage.getItem('token');
      const empresa = localStorage.getItem('emp');
      const url = `${process.env.VUE_APP_API_URL}/v1/unidadcomedor/`;
      const uri = `excelrptplatos?idempresa=${empresa}&activo=${this.filtro}&token=${token}`;
      window.location.href = `${url}${uri}`;
    }
  },
  async mounted() {
    this.gestionPlatoService = this.$httpService(new GestionPlatoService(), this);
    this.filtro = this.filtroOpciones[1].value;
  }
};
</script>
